import { render, staticRenderFns } from "./liveToBeReviewedReject.vue?vue&type=template&id=0e1db529"
import script from "./liveToBeReviewedReject.vue?vue&type=script&lang=js"
export * from "./liveToBeReviewedReject.vue?vue&type=script&lang=js"
import style0 from "./liveToBeReviewedReject.vue?vue&type=style&index=0&id=0e1db529&prod&lang=less&scope=true"
import style1 from "./liveToBeReviewedReject.vue?vue&type=style&index=1&id=0e1db529&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports